import React, { Component } from "react";
import clsx from 'clsx';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from "prop-types";
import {
    CssBaseline,
    CircularProgress,
    Container,
    Button,
    Grid,
    IconButton,
    Tooltip,
    Chip,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Switch
} from "@mui/material";
import { withStyles } from "@mui/styles";
import { Styles } from "../../styles/material-styles";
import { Overlay } from "../../styles/global";
import CustomizedSnackbars from "../../components/material-snackbars";
import HeaderMenu from "../../components/header-menu";
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import SendIcon from '@mui/icons-material/Send';
import { Link } from 'react-router-dom';
import Api from "../../services/api";
import * as WebhookService from '../../services/webhook.service';
import * as componentActions from '../../redux/actions/webhooks';
import MyMaterialTable from "../../components/table";
import { Can } from '../../config/ability-context';
import { AbilityContext } from '../../config/ability-context';
import { FormattedMessage, injectIntl } from 'react-intl';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Pagination from '@mui/material/Pagination';
import Search from '@mui/icons-material/Search';
import TextField from '@mui/material/TextField';
import Footer from '../../components/footer';
import SimpleSelect from '../../components/select/simple-search';
import ClearIcon from '@mui/icons-material/Clear';
import WebhookTestModal from '../../components/webhook-test-modal';

class WebhookList extends Component {

    constructor(props) {
        super(props);

        this.typingTimeout = null;

        const intl = this.props.intl;

        let filters = [
            { name: intl.formatMessage({ id: "name" }), id: "name" },
            { name: intl.formatMessage({ id: "webhook.endpoint.url" }), id: "url" },
            { name: intl.formatMessage({ id: "status" }), id: "status" },
        ];

        const { userSession } = this.props;
        this.state = {
            loading: false,
            openNotification: false,
            notificationVariant: "error",
            notificationMessage: "",
            resultList: [],
            totalPages: 0,
            page: 1,
            pageStart: 0,
            pageEnd: 0,
            count: 0,
            searchValue: '',
            filterSelected: 0,
            filters: filters,
            deleteDialogOpen: false,
            itemToDelete: null,
            pauseDialogOpen: false,
            itemToPause: null,
            testModalOpen: false,
            webhookToTest: null,
            eventTypes: [],
            selectedEventIds: []
        };

        this.changeValues = this.changeValues.bind(this);
        this.callSearch = this.callSearch.bind(this);
        this.onFieldChange = this.onFieldChange.bind(this);
        this.closeNotification = this.closeNotification.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
        this.clearFields = this.clearFields.bind(this);
        this.handleToggleActive = this.handleToggleActive.bind(this);
        this.handleTogglePause = this.handleTogglePause.bind(this);
        this.openTestModal = this.openTestModal.bind(this);
        this.closeTestModal = this.closeTestModal.bind(this);
        this.openPauseDialog = this.openPauseDialog.bind(this);
        this.closePauseDialog = this.closePauseDialog.bind(this);
        this.confirmPause = this.confirmPause.bind(this);
    }

    onChangePaginate = (e, page) => {
        this.setState({ page: page });
        this.getItens(page);
    }

    setPagination(count, page) {
        let totalPage = Math.ceil(count / 10);
        this.setState({ totalPages: totalPage });
        if (count > 0) {
            if (page == 1) {
                if (count < 10) {
                    this.setState({ pageStart: 1, pageEnd: count });
                } else {
                    this.setState({ pageStart: 1, pageEnd: 10 });
                }
            } else {
                let pageStart = ((page - 1) * 10) + 1;
                if (count >= page * 10) {
                    this.setState({ pageStart: pageStart, pageEnd: page * 10 });
                } else {
                    this.setState({ pageStart: pageStart, pageEnd: count });
                }
            }
        } else {
            this.setState({ totalPages: 0, page: 1, count: 0 });
        }
    }

    onFieldChange(event) {
        this.setState({ [event.target.name]: event.target.value, page: 1 });
    }

    callSearch() {
        if (this.state.filterSelected != 0) {
            this.getItens(this.state.page);
        }
    }

    async clearFields() {
        await this.setState({ filterSelected: 0, searchValue: '', page: 1 });
        this.getItens(1);
    }

    async changeValues(stateName, value, text = '') {
        this.setState({ filterSelected: value });
    }

    openDeleteDialog(item) {
        this.setState({ deleteDialogOpen: true, itemToDelete: item });
    }

    closeDeleteDialog() {
        this.setState({ deleteDialogOpen: false, itemToDelete: null });
    }

    async deleteItem() {
        const { itemToDelete } = this.state;
        if (!itemToDelete) return;

        this.setState({ loading: true });

        try {
            const result = await WebhookService.deleteWebhook(itemToDelete.id);

            if (result && result.success) {
                const intl = this.props.intl;
                this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: "success",
                    notificationMessage: intl.formatMessage({ id: "delete.sucess" }),
                    deleteDialogOpen: false,
                    itemToDelete: null
                });
                this.getItens(this.state.page);
            } else {
                const intl = this.props.intl;
                this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: 'error',
                    notificationMessage: result?.errors && result.errors[0] ? result.errors[0] : intl.formatMessage({ id: "process.error" }),
                    deleteDialogOpen: false,
                    itemToDelete: null
                });
            }
        } catch (err) {
            const intl = this.props.intl;
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: 'error',
                notificationMessage: intl.formatMessage({ id: "process.error" }),
                deleteDialogOpen: false,
                itemToDelete: null
            });
        }
    }

    async handleToggleActive(webhook) {
        this.setState({ loading: true });

        try {
            const result = await WebhookService.toggleWebhookActive(webhook.id, !webhook.isActive);

            if (result && result.success) {
                this.getItens(this.state.page);
            } else {
                const intl = this.props.intl;
                this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: 'error',
                    notificationMessage: result?.errors && result.errors[0] ? result.errors[0] : intl.formatMessage({ id: "process.error" })
                });
            }
        } catch (err) {
            const intl = this.props.intl;
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: 'error',
                notificationMessage: intl.formatMessage({ id: "process.error" })
            });
        }
    }

    async handleTogglePause(webhook) {
        // Se estiver pausado, retoma diretamente; se não, abre modal de confirmação
        if (webhook.isPaused) {
            this.setState({ loading: true });
            try {
                const result = await WebhookService.resumeWebhook(webhook.id);
                if (result && result.success) {
                    this.getItens(this.state.page);
                } else {
                    const intl = this.props.intl;
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: 'error',
                        notificationMessage: result?.errors && result.errors[0] ? result.errors[0] : intl.formatMessage({ id: "process.error" })
                    });
                }
            } catch (err) {
                const intl = this.props.intl;
                this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: 'error',
                    notificationMessage: intl.formatMessage({ id: "process.error" })
                });
            }
        } else {
            this.openPauseDialog(webhook);
        }
    }

    openPauseDialog(item) {
        this.setState({ pauseDialogOpen: true, itemToPause: item });
    }

    closePauseDialog() {
        this.setState({ pauseDialogOpen: false, itemToPause: null });
    }

    async confirmPause() {
        const { itemToPause } = this.state;
        if (!itemToPause) return;

        this.setState({ loading: true, pauseDialogOpen: false });

        // Incluir ID do usuário no motivo da pausa
        const { userSession } = this.props;
        const userId = userSession?.user?.id || userSession?.user?.Id || 'desconhecido';
        const pauseReason = `Pausado manualmente pelo usuário de id ${userId}`;

        try {
            const result = await WebhookService.pauseWebhook(itemToPause.id, pauseReason);

            if (result && result.success) {
                const intl = this.props.intl;
                this.setState({
                    openNotification: true,
                    notificationVariant: "success",
                    notificationMessage: intl.formatMessage({ id: "webhook.paused.success" }),
                    itemToPause: null
                });
                this.getItens(this.state.page);
            } else {
                const intl = this.props.intl;
                this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: 'error',
                    notificationMessage: result?.errors && result.errors[0] ? result.errors[0] : intl.formatMessage({ id: "process.error" }),
                    itemToPause: null
                });
            }
        } catch (err) {
            const intl = this.props.intl;
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: 'error',
                notificationMessage: intl.formatMessage({ id: "process.error" }),
                itemToPause: null
            });
        }
    }

    async openTestModal(webhook) {
        // Carregar subscriptions do webhook para obter os eventos selecionados
        try {
            const result = await WebhookService.getWebhookSubscriptions(webhook.id);
            let selectedEventIds = [];
            if (result && result.success && result.data) {
                selectedEventIds = result.data.map(sub => {
                    // Case-insensitive access
                    return sub.eventTypeId || sub.EventTypeId || sub.eventtypeid;
                }).filter(id => id != null);
            }
            this.setState({ testModalOpen: true, webhookToTest: webhook, selectedEventIds: selectedEventIds });
        } catch (err) {
            // Mesmo com erro, abre o modal sem eventos pré-selecionados
            this.setState({ testModalOpen: true, webhookToTest: webhook, selectedEventIds: [] });
        }
    }

    closeTestModal() {
        this.setState({ testModalOpen: false, webhookToTest: null });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.location.state === "reload") {
            this.componentDidMount();
        }
    }

    componentDidMount() {
        this.getItens(1);
        this.loadEventTypes();
    }

    async loadEventTypes() {
        try {
            const result = await WebhookService.getEventTypes();
            if (result && result.success) {
                this.setState({ eventTypes: result.data });
            }
        } catch (err) {
            // Silenciosamente ignora erro ao carregar tipos de eventos
        }
    }

    async getItens(page = 1) {
        this.setState({ loading: true });

        const { searchValue, filterSelected } = this.state;

        try {
            const result = await WebhookService.getWebhooks(page, searchValue, filterSelected);

            if (result && result.success) {
                let count = result.count;
                this.setState({ count: count });
                this.setPagination(count, page);

                const formattedList = result.data.map(item => {
                    // Helper case-insensitive
                    const getField = (obj, ...fields) => {
                        if (!obj) return undefined;
                        for (const field of fields) {
                            if (obj[field] !== undefined) return obj[field];
                            if (obj[field.toLowerCase()] !== undefined) return obj[field.toLowerCase()];
                            const pascal = field.charAt(0).toUpperCase() + field.slice(1);
                            if (obj[pascal] !== undefined) return obj[pascal];
                        }
                        return undefined;
                    };

                    const totalSuccess = getField(item, 'totalSuccessCount', 'TotalSuccessCount') || 0;
                    const totalFailure = getField(item, 'totalFailureCount', 'TotalFailureCount') || 0;
                    const successRate = totalSuccess + totalFailure > 0
                        ? ((totalSuccess / (totalSuccess + totalFailure)) * 100).toFixed(1)
                        : '-';

                    const lastTriggered = getField(item, 'lastTriggeredAt', 'LastTriggeredAt');

                    return {
                        ...item,
                        // Normalizar campos para acesso fácil
                        id: getField(item, 'id', 'Id'),
                        name: getField(item, 'name', 'Name'),
                        endpointUrl: getField(item, 'endpointUrl', 'EndpointUrl'),
                        httpMethod: getField(item, 'httpMethod', 'HttpMethod'),
                        isActive: getField(item, 'isActive', 'IsActive') ?? true,
                        isPaused: getField(item, 'isPaused', 'IsPaused') ?? false,
                        statusText: this.getStatusText(item),
                        successRate: successRate + '%',
                        lastTriggeredText: lastTriggered
                            ? new Date(lastTriggered).toLocaleString()
                            : '-'
                    };
                });

                this.setState({ loading: false, resultList: formattedList });
            } else {
                const intl = this.props.intl;
                this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage: result?.errors && result.errors[0] ? result.errors[0] : intl.formatMessage({ id: "process.error" })
                });
            }
        } catch (err) {
            const intl = this.props.intl;
            this.setState({
                loading: false,
                openNotification: true,
                notificationVariant: "error",
                notificationMessage: intl.formatMessage({ id: "process.error" })
            });
        }
    }

    getStatusText(item) {
        const intl = this.props.intl;
        const isActive = item.isActive ?? item.IsActive ?? true;
        const isPaused = item.isPaused ?? item.IsPaused ?? false;

        if (!isActive) {
            return intl.formatMessage({ id: "webhook.status.inactive" });
        }
        if (isPaused) {
            return intl.formatMessage({ id: "webhook.status.paused" });
        }
        return intl.formatMessage({ id: "webhook.status.active" });
    }

    getStatusChip(rowData) {
        const intl = this.props.intl;
        const isActive = rowData.isActive ?? rowData.IsActive ?? true;
        const isPaused = rowData.isPaused ?? rowData.IsPaused ?? false;

        if (!isActive) {
            return <Chip label={intl.formatMessage({ id: "webhook.status.inactive" })} size="small" style={{ backgroundColor: '#9e9e9e', color: 'white' }} />;
        }
        if (isPaused) {
            return <Chip label={intl.formatMessage({ id: "webhook.status.paused" })} size="small" style={{ backgroundColor: '#ff9800', color: 'white' }} />;
        }
        return <Chip label={intl.formatMessage({ id: "webhook.status.active" })} size="small" style={{ backgroundColor: '#4caf50', color: 'white' }} />;
    }

    closeNotification() {
        this.setState({ openNotification: false });
    }

    render() {
        const { classes, headerMenu, actionsHeaderMenu } = this.props;
        const intl = this.props.intl;

        if (Api == null) {
            var l = this.props.match.params.lang;
            document.location.href = `/${l}/unavailable`;
        }

        return (
            <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
                <HeaderMenu />
                <main
                    className={clsx(classes.content, {
                        [classes.contentShift]: headerMenu.open,
                    }, classes.actionsContent, {
                        [classes.actionscontentShift]: actionsHeaderMenu.open,
                    })}
                >
                    <div className={classes.drawerHeader} />

                    <Container component='main' maxWidth='xl' style={{ maxWidth: '100%', paddingLeft: 0, marginLeft: 0 }}>
                        <CssBaseline />
                        <Grid container className={classes.mb20} spacing={0}>
                            <Button
                                variant="contained"
                                color="secondary"
                                size="large"
                                className={classes.button}
                                startIcon={<AddIcon />}
                                component={Link} {...{ to: `/${this.props.match.params.lang}/webhook-registration` }}
                            >
                                {<FormattedMessage id="add" />}
                            </Button>
                        </Grid>

                        <Grid container spacing={6}>
                            <Grid item xs={12} sm={12}>
                                <Card className="background-title-search">
                                    <CardContent>
                                        <Grid container spacing={1} alignItems="flex-end">
                                            <Grid item xs={12} md={6}>
                                                <Typography variant="h5">
                                                    {<FormattedMessage id="webhook.header" />}
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} md={2}>
                                                <SimpleSelect
                                                    label={intl.formatMessage({ id: "field" })}
                                                    options={this.state.filters}
                                                    stateName='filter'
                                                    changeSelect={this.changeValues}
                                                    selected={this.state.filterSelected}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <Search />
                                            </Grid>
                                            <Grid item >
                                                <TextField
                                                    type="text"
                                                    name="searchValue"
                                                    value={this.state.searchValue}
                                                    placeholder={intl.formatMessage({ id: "search" })}
                                                    onChange={this.onFieldChange}
                                                />
                                                <Button
                                                    variant='contained'
                                                    color='secondary'
                                                    size='large'
                                                    className={classes.button}
                                                    style={{ marginRight: 4, marginLeft: 8 }}
                                                    onClick={this.callSearch}
                                                >
                                                    <Search />
                                                </Button>
                                                <Button
                                                    variant='contained'
                                                    color='primary'
                                                    size='large'
                                                    onClick={this.clearFields}
                                                    className={classes.button}
                                                >
                                                    <ClearIcon />
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>

                        <MyMaterialTable
                            title=""
                            rowClick={(event, rowData) => {
                                const webhookId = rowData.id || rowData.Id;
                                this.props.history.push(`/${this.props.match.params.lang}/webhook-edit/${webhookId}`);
                            }}
                            columns={[
                                { title: intl.formatMessage({ id: "name" }), field: 'name', render: rowData => rowData.name || rowData.Name },
                                { title: intl.formatMessage({ id: "webhook.endpoint.url" }), field: 'endpointUrl', render: rowData => rowData.endpointUrl || rowData.EndpointUrl },
                                { title: intl.formatMessage({ id: "webhook.http.method" }), field: 'httpMethod', render: rowData => rowData.httpMethod || rowData.HttpMethod },
                                {
                                    title: intl.formatMessage({ id: "status" }),
                                    field: 'statusText',
                                    render: rowData => this.getStatusChip(rowData)
                                },
                                { title: intl.formatMessage({ id: "webhook.success.rate" }), field: 'successRate' },
                                { title: intl.formatMessage({ id: "webhook.last.triggered" }), field: 'lastTriggeredText' },
                            ]}
                            data={this.state.resultList}
                            action={[
                                {
                                    icon: () => <SendIcon color="primary" />,
                                    tooltip: intl.formatMessage({ id: 'webhook.test' }),
                                    onClick: (event, rowData) => {
                                        event.stopPropagation();
                                        this.openTestModal(rowData);
                                    }
                                },
                                rowData => ({
                                    icon: () => rowData.isPaused ? <PlayCircleOutlineIcon color="success" /> : <PauseIcon color="warning" />,
                                    tooltip: rowData.isPaused
                                        ? intl.formatMessage({ id: 'webhook.resume' })
                                        : intl.formatMessage({ id: 'webhook.pause' }),
                                    onClick: (event, rowData) => {
                                        event.stopPropagation();
                                        this.handleTogglePause(rowData);
                                    }
                                }),
                                {
                                    icon: () => <DeleteIcon color="error" />,
                                    tooltip: intl.formatMessage({ id: 'delete' }),
                                    onClick: (event, rowData) => {
                                        event.stopPropagation();
                                        this.openDeleteDialog(rowData);
                                    }
                                }
                            ]}
                        />

                        <Grid container style={{ marginBottom: 12, marginTop: 8 }}>
                            <Grid item xs={12} md={3}>
                                <Pagination
                                    count={this.state.totalPages}
                                    page={this.state.page}
                                    onChange={this.onChangePaginate}
                                />
                            </Grid>
                            <Grid item xs={12} sm={3} style={{ marginTop: 6 }}>
                                {this.state.pageStart} {<FormattedMessage id="to" />} {this.state.pageEnd} {<FormattedMessage id="of" />} {this.state.count} {<FormattedMessage id="register" />}
                            </Grid>
                        </Grid>

                        {this.state.loading && (
                            <Overlay>
                                <CircularProgress color="secondary" />
                            </Overlay>
                        )}

                        <CustomizedSnackbars
                            variant={this.state.notificationVariant}
                            message={this.state.notificationMessage}
                            isOpen={this.state.openNotification}
                            toClose={this.closeNotification}
                        />

                        {/* Delete Confirmation Dialog */}
                        <Dialog
                            open={this.state.deleteDialogOpen}
                            onClose={() => this.closeDeleteDialog()}
                        >
                            <DialogTitle>
                                {intl.formatMessage({ id: 'webhook.delete.title' })}
                            </DialogTitle>
                            <DialogContent>
                                <DialogContentText>
                                    {intl.formatMessage({ id: 'webhook.delete.confirm' })}
                                    {this.state.itemToDelete && (
                                        <strong> {this.state.itemToDelete.name}</strong>
                                    )}?
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => this.closeDeleteDialog()} color="primary">
                                    {intl.formatMessage({ id: 'cancel' })}
                                </Button>
                                <Button onClick={() => this.deleteItem()} color="error" variant="contained">
                                    {intl.formatMessage({ id: 'delete' })}
                                </Button>
                            </DialogActions>
                        </Dialog>

                        {/* Pause Confirmation Dialog */}
                        <Dialog
                            open={this.state.pauseDialogOpen}
                            onClose={() => this.closePauseDialog()}
                        >
                            <DialogTitle>
                                {intl.formatMessage({ id: 'webhook.pause.title' })}
                            </DialogTitle>
                            <DialogContent>
                                <DialogContentText>
                                    {intl.formatMessage({ id: 'webhook.pause.confirm' })}
                                    {this.state.itemToPause && (
                                        <strong> {this.state.itemToPause.name || this.state.itemToPause.Name}</strong>
                                    )}?
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => this.closePauseDialog()} color="primary">
                                    {intl.formatMessage({ id: 'cancel' })}
                                </Button>
                                <Button onClick={() => this.confirmPause()} color="warning" variant="contained">
                                    {intl.formatMessage({ id: 'webhook.pause' })}
                                </Button>
                            </DialogActions>
                        </Dialog>

                        {/* Test Modal */}
                        <WebhookTestModal
                            isOpen={this.state.testModalOpen}
                            handleClose={this.closeTestModal}
                            webhookId={this.state.webhookToTest?.id || this.state.webhookToTest?.Id}
                            webhookName={this.state.webhookToTest?.name || this.state.webhookToTest?.Name}
                            eventTypes={this.state.eventTypes}
                            selectedEventIds={this.state.selectedEventIds}
                        />
                    </Container>
                </main>
                <Footer />
            </div>
        );
    }
}

WebhookList.propTypes = {
    classes: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    actionsHeaderMenu: state.actionsHeaderMenu,
    headerMenu: state.headerMenu,
    userSession: state.userSession,
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(componentActions, dispatch);

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(WebhookList)));

WebhookList.contextType = AbilityContext;
